/**
 * Demo network data for the /network Network Explorer.
 * Realistic, but clearly labeled DEMO DATA in the UI.
 */

export const COUNTRIES = ["India", "UAE", "Singapore", "UK", "France", "Germany", "US", "Japan"];
export const VENUE_TYPES = ["Café", "Retail", "Airport", "Metro", "Mall", "Coworking", "Gym", "Hotel", "University", "Cinema"];
export const MEDIA_TYPES = ["LED", "LCD", "Projection", "E-paper", "Kiosk"];
export const ENVIRONMENTS = ["Street", "Retail", "Transit", "Hospitality", "Workplace", "Education", "Entertainment", "Mobility"];

// Approximate SVG coordinates on a 1000×500 world plate (equirectangular-ish; not geo-accurate — this is DEMO DATA)
const CITY_COORDS = {
  Mumbai: { x: 692, y: 260, country: "India" },
  Delhi: { x: 690, y: 220, country: "India" },
  Bengaluru: { x: 700, y: 280, country: "India" },
  Dubai: { x: 640, y: 240, country: "UAE" },
  Singapore: { x: 780, y: 300, country: "Singapore" },
  London: { x: 500, y: 175, country: "UK" },
  Paris: { x: 510, y: 190, country: "France" },
  Berlin: { x: 530, y: 180, country: "Germany" },
  "New York": { x: 300, y: 215, country: "US" },
  "Los Angeles": { x: 210, y: 235, country: "US" },
  Tokyo: { x: 840, y: 225, country: "Japan" },
};

const NAMES = [
  "Bandra High Street", "Koramangala Node 7", "DLF Cyber Hub",
  "Marina Bay Corridor", "Downtown Metro", "Shibuya Crossing",
  "Dubai Marina Walk", "King's Cross Arcade", "Le Marais Retail",
  "Mitte Studio Row", "Manhattan Plaza", "Venice Beach Boardwalk",
  "Airport Terminal Loop", "Central Mall Concourse", "Third Wave Café",
  "Innovation Coworking", "Fitness First Plaza", "Grand Hotel Lobby",
  "Regent Cinemas", "IIT Campus Center",
];

const CONTEXTS = [
  "Peak commute", "Retail lunch", "Late-night", "Post-office", "Weekend leisure",
  "Fitness rush", "Travel dwell", "Airport transit", "Student break", "Cinema queue",
];

let idCounter = 0;
function nextEndpoint(city, coord) {
  idCounter++;
  const venue = VENUE_TYPES[idCounter % VENUE_TYPES.length];
  const media = MEDIA_TYPES[idCounter % MEDIA_TYPES.length];
  const env = ENVIRONMENTS[idCounter % ENVIRONMENTS.length];
  const name = NAMES[idCounter % NAMES.length];
  const context = CONTEXTS[idCounter % CONTEXTS.length];
  const cpm = 8 + ((idCounter * 7) % 50);
  const dwell = 5 + ((idCounter * 11) % 55);
  const audience = 500 + ((idCounter * 233) % 20000);
  const jitterX = ((idCounter * 13) % 20) - 10;
  const jitterY = ((idCounter * 17) % 12) - 6;
  const status = idCounter % 9 === 0 ? "verification_pending" : "verified";
  return {
    id: `ml_${idCounter.toString(36).padStart(3, "0")}`,
    handle: `mirrorloops://${coord.country.toLowerCase().replace(/\s/g,"-")}/${city.toLowerCase().replace(/\s/g,"-")}/${name.toLowerCase().replace(/[^a-z0-9]+/g,"-")}/screen-${(idCounter%9)+1}`,
    name,
    city,
    country: coord.country,
    venue_type: venue,
    media_type: media,
    environment: env,
    context,
    cpm,
    dwell_sec: dwell,
    audience_daily: audience,
    resolution: idCounter % 3 === 0 ? "3840×2160" : idCounter % 2 === 0 ? "1920×1080" : "1080×1920",
    orientation: idCounter % 3 === 0 ? "portrait" : "landscape",
    availability: idCounter % 5 === 0 ? "booked" : "available",
    status,
    proof_of_play: idCounter % 4 !== 0,
    x: coord.x + jitterX,
    y: coord.y + jitterY,
  };
}

export const ENDPOINTS = (() => {
  const out = [];
  Object.entries(CITY_COORDS).forEach(([city, coord]) => {
    // between 4 and 7 endpoints per city
    const n = 4 + (Math.abs(city.length) % 4);
    for (let i = 0; i < n; i++) out.push(nextEndpoint(city, coord));
  });
  return out;
})();

export const CITY_STATS = Object.entries(CITY_COORDS).map(([city, coord]) => ({
  city,
  country: coord.country,
  x: coord.x,
  y: coord.y,
  endpoints: ENDPOINTS.filter((e) => e.city === city).length,
}));
